import { atomWithStorage } from 'jotai/utils'

/**
 * What a user has done with the post-onboarding context notification.
 *
 * `eligible` is decided once, from the first snapshot seen after onboarding,
 * so an existing account whose context refreshes later never sees it.
 */
export interface ContextNotificationRecord {
  eligible: boolean
  minimized: boolean
  dismissed: boolean
}

/** Keyed by user id, so switching accounts on one machine never overwrites another's decision. */
export const contextNotificationRecordsAtom = atomWithStorage<Record<string, ContextNotificationRecord>>(
  'highlight:contextNotifications',
  {},
)

/** Forces one of the three states regardless of account state. Developer menu only. */
export type ContextNotificationMock = 'progress' | 'minimized' | 'finished'

export const contextNotificationMockAtom = atomWithStorage<ContextNotificationMock | null>(
  'highlight:contextNotificationMock',
  null,
)
